// rp-electra100.js
// Scroll-reveal for .rp-e100-animate elements, plus Shopify theme-editor
// support so merchants see a block highlighted/scrolled-into-view when
// they select it in the sidebar (standard Dawn pattern).

document.addEventListener('DOMContentLoaded', function () {
  var revealEls = document.querySelectorAll('.rp-e100-animate');

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }
});

// Theme editor: bring newly-selected blocks into view and reveal them
// immediately, even if they haven't scrolled into the viewport naturally.
document.addEventListener('shopify:block:select', function (event) {
  event.target.classList.add('is-visible');
  event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
});